module.exports = __webpack_public_path__ + "img/TECNOLOGIA-ERTIGA-1.c8877842.jpg";